import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=4de5c680&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"
import style0 from "./reservation.vue?vue&type=style&index=0&id=4de5c680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5c680",
  null
  
)

export default component.exports